/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Subscription } from '../models/Subscription';
import type { SubscriptionInput } from '../models/SubscriptionInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionsService {
    /**
     * List all subscriptions
     * @param page Page number
     * @param limit Items per page
     * @returns any Successful operation
     * @throws ApiError
     */
    public static listSubscriptions(
        page: number = 1,
        limit: number = 10,
    ): CancelablePromise<{
        items?: Array<Subscription>;
        total?: number;
        page?: number;
        limit?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscriptions',
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * Create a new subscription
     * @param requestBody
     * @returns Subscription Subscription created successfully
     * @throws ApiError
     */
    public static createSubscription(
        requestBody: SubscriptionInput,
    ): CancelablePromise<Subscription> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscriptions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all subscriptions for a specific user
     * @param userId ID of the user to get subscriptions for
     * @param page Page number
     * @param limit Items per page
     * @returns any Successful operation
     * @throws ApiError
     */
    public static getUserSubscriptions(
        userId: string,
        page: number = 1,
        limit: number = 10,
    ): CancelablePromise<{
        items?: Array<Subscription>;
        total?: number;
        page?: number;
        limit?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscriptions/user/{user_id}',
            path: {
                'user_id': userId,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                404: `User not found`,
            },
        });
    }
    /**
     * Get subscription by ID
     * @param id
     * @returns Subscription Successful operation
     * @throws ApiError
     */
    public static getSubscription(
        id: string,
    ): CancelablePromise<Subscription> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscriptions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Subscription not found`,
            },
        });
    }
    /**
     * Update subscription
     * @param id
     * @param requestBody
     * @returns Subscription Subscription updated successfully
     * @throws ApiError
     */
    public static updateSubscription(
        id: string,
        requestBody: SubscriptionInput,
    ): CancelablePromise<Subscription> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/subscriptions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Subscription not found`,
            },
        });
    }
    /**
     * Delete subscription
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteSubscription(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/subscriptions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Subscription not found`,
            },
        });
    }
}
